import { render, staticRenderFns } from "./HeroGravityVisual.vue?vue&type=template&id=b86d85d0&scoped=true"
import script from "./HeroGravityVisual.vue?vue&type=script&lang=js"
export * from "./HeroGravityVisual.vue?vue&type=script&lang=js"
import style0 from "./HeroGravityVisual.vue?vue&type=style&index=0&id=b86d85d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86d85d0",
  null
  
)

export default component.exports